import { useDelayedUnmount } from "../../hooks/useDelayedUnmount";

/**
 * 延迟卸载容器：让条件渲染的弹层也能播出场动画。
 * 适用于无法直接挂 hook 的位置（如 map 循环内部）：
 *
 *   <Exitable
 *     open={show}
 *     className="absolute top-full ..."
 *     enterClass="animate-in fade-in zoom-in-95 duration-200"
 *     exitClass="animate-out fade-out zoom-out-95 duration-150"
 *   >
 *     ...内容...
 *   </Exitable>
 */
const Exitable = ({
  open,
  duration = 150,
  enterClass = "",
  exitClass = "",
  className = "",
  style,
  children,
  ...rest
}) => {
  const m = useDelayedUnmount(open, duration);
  if (!m.mounted) return null;
  return (
    <div
      className={`${className} ${m.exiting ? exitClass : enterClass}`.trim()}
      style={style}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Exitable;
